import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import ko from "knockout";
import { INumberParams } from "./number";
import viewHtml from "./number-comma-decimal.html";

ko.components.register("ko-number-comma-decimal", {
    viewModel: function (params: INumberParams) {
        this.value = params.value;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_number_comma_decimal", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
